export const FormState = {
  OPEN: 1,
  CLOSED: 2,
  CANCELLED: 3,
  READY_TO_IMPORT: 4,
}

export const FormAState = {
  OPEN: 1,
  CLOSED_AND_VALIDATED: 2,
}

export const FormBState = {
  OPEN: 1,
  CLOSED_AND_VALIDATED: 2,
}

export const formTabs = _vm => [
  {
    id: 'A',
    title: _vm.$t('models.enums.FormTabs.A'),
  },
  {
    id: 'B',
    title: _vm.$t('models.enums.FormTabs.B'),
  },
  {
    id: 'DETAIL',
    title: _vm.$t('models.enums.FormTabs.DETAIL'),
  },
]
